import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { Application, extend } from "@pixi/react";
import { TextureSource, Graphics, Container, Sprite, BitmapText, EventSystem, } from "pixi.js";
extend({
    Container,
    Graphics,
    BitmapText,
    Sprite,
});
TextureSource.defaultOptions.scaleMode = "nearest";
EventSystem.defaultEventFeatures.move = true;
EventSystem.defaultEventFeatures.globalMove = true;
EventSystem.defaultEventFeatures.click = true;
EventSystem.defaultEventFeatures.wheel = true;
export const PosconStage = ({ children, backgroundColor = 0, width, height, resizeToWindow = true, }) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const handleInit = useCallback((app) => {
        app.stage.eventMode = "static";
        app.stage.hitArea = app.screen;
        app.stage.sortableChildren = true;
        setIsInitialized(true);
        // @ts-ignore
        globalThis.__PIXI_APP__ = app;
    }, []);
    return (_jsx(Application, { preference: "webgl", resizeTo: resizeToWindow ? window : undefined, resolution: 1, antialias: false, roundPixels: false, eventMode: "static", autoStart: true, backgroundColor: backgroundColor, onInit: handleInit, width: width, height: height, children: isInitialized && children }));
};
//# sourceMappingURL=PosconStage.js.map